import { DEFAULT_GUTTER } from './config2.js';

function getFormattedGutterValue(val) {
  if (typeof val === "number") {
    return [val, val];
  } else if (val instanceof Array && val.length >= 2 && val.every((item) => typeof item === "number")) {
    return [val[0], val[1]];
  }
  return DEFAULT_GUTTER;
}

export { getFormattedGutterValue };
//# sourceMappingURL=utils2.js.map
